import { collection } from 'firebase/firestore';
import { db } from '../../config';

/**
 * inquiriesコレクションの参照
 */
export const inquiriesRef = collection(db, 'inquiries');
